import { sendMixPanelEvent } from '../../../Utils/mixpanel';
import { CANCEL_NEW_COMMENT } from '../../../Utils/mixpanel/mixpanelEvents';
import { getCurrentCollaborator } from '../../selectors/collaborators';
import { COMMENT_BOX_CANCELLED, COMMENT_BOX_OPENED } from './types';
import { commentBoxEventsBus, COMMENT_BOX_FOCUS_EVENT } from '.';

export const commentBoxCancelled = (payload) => (dispatch, getState) => {
    const { userId } = getCurrentCollaborator(getState());

    sendMixPanelEvent({
        eventName: CANCEL_NEW_COMMENT,
        eventData: {
            'Has text': !!payload.text,
            'Has Annotation': !!getState().tempAnnotations.length,
            'Is Collaborator': !userId
        }
    });

    dispatch({
        type: COMMENT_BOX_CANCELLED,
        payload
    });
};

export const commentBoxOpened = (payload) => (dispatch) => {
    dispatch({
        type: COMMENT_BOX_OPENED,
        payload
    });
};

export function emitCommentBoxGotFocus() {
    return () => {
        commentBoxEventsBus.emit(COMMENT_BOX_FOCUS_EVENT);
    };
}
